var myTitle = document.title;
    function titleBlink() {
        _record++;
        if (_record == 3) { //When the variable accumulates to 3, assign it to 1. It's the equivalent of an infinite loop.
            _record = 1;
        }
        if (_record == 1) {
            document.title = myTitle;
        }
        if (_record == 2) {
            document.title = window.blurTitle||myTitle;
        }

    }
    // Browser compatibility scheme
    var hidden, state, visibilityChange, timer;
    if (typeof document.hidden !== "undefined") {
        hidden = "hidden";
        visibilityChange = "visibilitychange";
        state = "visibilityState";
    } else if (typeof document.mozHidden !== "undefined") {
        hidden = "mozHidden";
        visibilityChange = "mozvisibilitychange";
        state = "mozVisibilityState";
    } else if (typeof document.msHidden !== "undefined") {
        hidden = "msHidden";
        visibilityChange = "msvisibilitychange";
        state = "msVisibilityState";
    } else if (typeof document.webkitHidden !== "undefined") {
        hidden = "webkitHidden";
        visibilityChange = "webkitvisibilitychange";
        state = "webkitVisibilityState";
    }
    document.addEventListener(visibilityChange, function() {
        if (document[state] == "visible") {
            clearInterval(timer);
            document.title = myTitle;

        } else {
            _record = 0;
            timer = setInterval("titleBlink()", 500);
        }

    }, false);